import removeTags from '../removeTags'

export default (hit, size) => {
  let picSizes = [[419, 236], [360, 203], [443, 250], [679, 366], [334, 180]]
  const isArticle = hit.type === 'article'

  let date = new Date(hit.publicationDate.date)
  date = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`
  const startDate = hit.startEventDate ? new Date(hit.startEventDate.date) : null
  const endDate = hit.endEventDate ? new Date(hit.endEventDate.date) : null
  let ctaLabel = ''
  let tag = ''

  if (size === 'L') {
    picSizes = [[656, 290], [560, 247], [443, 250], [679, 366], [334, 180]]
  }

  if (hit.type === 'article') {
    ctaLabel = 'Lire l\'actualité'
    tag = 'Actualité'
  } else if (hit.type === 'event') {
    ctaLabel = 'Voir l\'événement'
    tag = 'événement'
  } else {
    ctaLabel = 'Voir l\'événement'
    tag = 'Agenda CGF'
  }

  return `
  <div class="card-common card-common--${size} card-news-event ${!isArticle ? 'card-news-event--event' : ''}">
    <a href="/${hit.path}" class="card-common__wrap">
      <div class="card-common__tags">
        <span class="tag">${tag}</span>
      </div>

      <div class="relative ${!isArticle ? 'mb-1 md:mb-3' : 'card-news-event__top--article'} card-news-event__top card-news-event__top--${size}">
        <picture class="card-common__pic ${!isArticle ? `card-common__pic--news card-common__pic--news-${size}` : ''}">
          <source media="(max-width:420px)" data-srcset="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[4][0]},h_${picSizes[4][1]}/${hit.image.singleMedia.publicId}">
          <source media="(max-width:767px)" data-srcset="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[3][0]},h_${picSizes[3][1]}/${hit.image.singleMedia.publicId}">
          <source width="${picSizes[2][0]}" height="${picSizes[2][1]}" media="(max-width:1023px)" data-srcset="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[2][0]},h_${picSizes[2][1]}/${hit.image.singleMedia.publicId}">
          <source width="${picSizes[1][0]}" height="${picSizes[1][1]}" media="(max-width:1279px)" data-srcset="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[1][0]},h_${picSizes[1][1]}/${hit.image.singleMedia.publicId}">
          <img class="w-full lazyload" width="${picSizes[0][0]}" height="${picSizes[0][1]}" data-src="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[1][0]},h_${picSizes[1][1]}/${hit.image.singleMedia.publicId}" alt="${hit.image.singleMedia.alt}"/>
        </picture>

        ${!isArticle
          ? `<div class="card-news-event__date card-news-event__date--${size}">
              <span>${startDate.getDate().toString().padStart(2, '0')}.${(startDate.getMonth() + 1).toString().padStart(2, '0')}</span>
              ${endDate !== null
                ? `<span>${endDate.getDate().toString().padStart(2, '0')}.${(endDate.getMonth() + 1).toString().padStart(2, '0')}</span>
                  <span class="year">${endDate.getFullYear()}</span>`
                : `<span class="year">${startDate.getFullYear()}</span>`
              }
            </div>`
          : ''
        }
      </div>

      <div class="card-common__inner ${size === 'S' ? 'card-common__inner--S' : ''} mt-5">
        <div>
          ${isArticle
            ? `<p class="card-common__date text-grey-dark">
                <svg width="12" height="12" class="mr-2 icon--violet">
                  <use href="#icon-hour" xlink:href="#icon-hour"></use>
                </svg>
                <span>Publié le <span class="font-bold text-violet">${date}</span></span>
              </p>`
            : ''
          }

          <p class="title-card title-card--${size} ${isArticle ? 'text-violet' : 'text-white'} mb-3">
            ${hit.title}
          </p>

          ${isArticle
            ? hit.description !== null && hit.description !== '' ? `<div class="card-publi__chapo">${removeTags(hit.description)}</div>` : ''
            : hit.place !== null && hit.place !== ''
              ? `<div class="flex card-news-event__location">
                  <svg width="14" height="20" class="mr-2 icon--orange flex-shrink-0">
                      <use href="#icon-pin" xlink:href="#icon-pin"></use>
                  </svg>
                  ${hit.place}
                </div>`
              : ''
          }
        </div>

        <span class="cta-arrow ${isArticle ? 'text-violet' : 'text-white'} mt-5">
          ${ctaLabel}

          <span class="cta-arrow__circle">
            <svg width="8" height="8" class="icon--white">
              <use href="#icon-arrow" xlink:href="#icon-arrow"></use>
            </svg>
          </span>
        </span>
      </div>
    </a>

    ${!isArticle && hit.registerLink !== null && hit.registerLink !== ''
      ? `<a href="${hit.registerLink}" target="_blank" rel="nofollow" class="card-common__action icon-center">
          <svg width="20" height="18" class="icon--white">
              <use href="#icon-calendar" xlink:href="#icon-calendar"></use>
          </svg>
          <span class="sr-only">S'inscrire à l'évènement</span>
        </a>`
      : ''
    }
  </div>
  `
}
